import React, {FunctionComponent} from "react";
import {Main} from './components/Main';
import {useModelContext} from "@app/contexts/model";
import {observer} from "mobx-react";


export const Translate: FunctionComponent = observer(() => {

    const {languageModel} = useModelContext();

    let getDataCategory = languageModel.getLanguageCategory()


   return <div >
    {getDataCategory && <Main />}
   </div>
})
